import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  TextField,
  Button,
} from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { CustomButton } from "../../../../../components/CustomButton/CustomButton";

const ShippingDetailsModel = ({
  open,
  onClose,
  handleChange,
  handleSubmit,
  shippingDetails,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{ padding: "0" }}
    >
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          Enter shipping details (optional)
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent>
        <TextField
          fullWidth
          margin="normal"
          label="Shipping Partner (optional)"
          name="shippingPartner"
          value={shippingDetails.shippingPartner}
          onChange={handleChange}
          variant="outlined"
          helperText="Leave blank if unknown"
        />
        <TextField
          fullWidth
          margin="normal"
          label="Tracking Number (optional)"
          name="trackingNumber"
          value={shippingDetails.trackingNumber}
          onChange={handleChange}
          variant="outlined"
          helperText="Can be added later"
        />
      </DialogContent>

      <DialogActions sx={{ padding: "20px" }}>
        <CustomButton
          variant="contained"
          onClick={handleSubmit}
          // Button is always enabled now
        >
          {shippingDetails.shippingPartner || shippingDetails.trackingNumber
            ? "Save Details"
            : "Skip Shipping Info"}
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default ShippingDetailsModel;
